import React, { useEffect } from "react";
import AccommodationInfo from "./AccommodationInfo";
import useGet from "../../../../../hooks/useGet";
import { decode } from "../../../utilities/hash";
import { useParams } from "react-router-dom";
import queryString from "query-string";
import EmployeeDetails from "../../EmployeeDetails/EmployeeDetails";
import CorrespondenceTab from "./CorrespondenceTab";
import { Experience } from "../../../../../types/Experience";
import useAuthentication from "../../../../../hooks/useAuthentication";
import NotesTab from "./NotesTab";
import RequestDetailsTab from "./RequestDetailsTab";
import useTealium from "../../../../../hooks/useTealium";
import { TEALIUM_PAGE_VIEW } from "../../../../../constants/tealiumConstants";
import { TabContainer } from '@digitools/honest-react';
import { Breadcrumb, Breadcrumbs } from '@digitools/honest-ui';
import Heading from "@digitools/honest-react/dist/lib/components/Heading";
import Spinner from "@digitools/honest-react/dist/lib/components/Spinner";
import titleCase from "src/packages/status/utilities/titleCase";
import { useHomePageBreadcrumbs, useStatusBreadcrumbs } from 'src/components/Breadcrumbs';
import useExperience from '../../../../../hooks/useExperience';
import useTranslate from 'src/hooks/useTranslate';
import StatusText from 'src/packages/status/i18n/StatusText';
import BreadcrumbText from 'src/packages/status/i18n/BreadcrumbText';
//TODO: Add analytics for breadcrumbs
const AccommodationDetails = () => {
    const { experience } = useExperience();
    const { user } = useAuthentication();
    const { t } = useTranslate();
    const { callForHelp } = StatusText;
    const { accommodationDetails } = BreadcrumbText;
    const { empNum, eventId } = useParams();
    const { trackView } = useTealium();
    const params = queryString.parse(location.search);
    useEffect(() => {
        trackView({
            page_l3: TEALIUM_PAGE_VIEW.PAGE_L3.STATUS,
            page_l5: TEALIUM_PAGE_VIEW.PAGE_L5.STATUS.ACCOMMODATION_DETAILS,
            page_l6: TEALIUM_PAGE_VIEW.PAGE_L6.STATUS.ACCOMMODATION_DETAILS
        });
    }, []);
    const decodedEmpNum = decode(empNum);
    const accommodationEventId = decode(eventId);
    window.scrollTo(0, 0); // FIXME: wtf is this for?
    let showExtendedView = false;
    let showRequestsTab = false;
    const accommodationdetailsbaseUrl = "/status-service/accommodations/" + accommodationEventId;
    let accommodationDetailsUrl;
    if (experience === Experience.EMPLOYEE) {
        showRequestsTab = user.applicationPermissions.indexOf("statusEE.viewAccommodationStatus.viewBasicAsRequest") > -1;
        accommodationDetailsUrl = accommodationdetailsbaseUrl + "/basicDetails";
    }
    else if (experience === Experience.EMPLOYER) {
        showExtendedView = user.applicationPermissions.indexOf("statusER.viewAccommodationStatus.viewFullAsRequest") > -1;
        showRequestsTab = user.applicationPermissions.indexOf("statusER.viewAccommodationStatus.viewBasicAsRequest") > -1;
        accommodationDetailsUrl = showExtendedView ? accommodationdetailsbaseUrl + "/extendedDetails" : accommodationdetailsbaseUrl + "/basicDetails";
    }
    const { loading: loadingAccommodationDetails, data: accommodationDetailsData } = useGet({ url: accommodationDetailsUrl });
    const { data: employeeData, } = useGet({
        url: '/status-service/employee/search/searchByEmpNum',
        options: {
            params: {
                empNum: decodedEmpNum,
            },
        },
    });
    if (loadingAccommodationDetails) {
        return <div data-testid="accomodation-loading"><Spinner id="accommodation-details-spinner"/></div>;
    }
    let showCorrespondenceTab = false;
    let showNotesTab = false;
    if (experience === Experience.EMPLOYEE) {
        showCorrespondenceTab =
            user.applicationPermissions.indexOf("statusEE.viewAccommodationStatus.viewAsCorrespondence") > -1;
    }
    else if (experience === Experience.EMPLOYER) {
        showCorrespondenceTab =
            user.applicationPermissions.indexOf("statusER.viewAccommodationStatus.viewAsCorrespondence") > -1;
        showNotesTab = user.applicationPermissions.indexOf("statusER.viewAccommodationStatus.asNotes") > -1;
    }
    const empName = employeeData?.empFirstName && employeeData?.empLastName
        ? `${titleCase(employeeData.empFirstName)} ${titleCase(employeeData.empLastName)}`
        : null;
    return (<div data-public={true}>
      <Breadcrumbs>
        {useHomePageBreadcrumbs()}
        {useStatusBreadcrumbs(decodedEmpNum, experience, params, location)}
        <Breadcrumb>{t(accommodationDetails)}</Breadcrumb>
      </Breadcrumbs>
      <Heading data-testid="accommodation-details-header">{t(accommodationDetails)}</Heading>
      <EmployeeDetails empNum={decodedEmpNum} empEmailAddress={employeeData?.empEmailAddr}/>
      <br />
      <div className="mb-4">
        <AccommodationInfo detailsData={accommodationDetailsData} employeeName={empName}/>
      </div>
      <TabContainer>
        {showRequestsTab && <RequestDetailsTab accommodationRequestDetails={accommodationDetailsData?.accommodationRequestDetails} showExtendedView={showExtendedView}/>}
        {showCorrespondenceTab && <CorrespondenceTab accommodationId={accommodationEventId}/>}
        {showNotesTab && <NotesTab accommodationId={accommodationEventId} employeeNumber={decodedEmpNum}/>}
      </TabContainer>
    </div>);
};
export default AccommodationDetails;
